import { render, staticRenderFns } from "./SetStatusInProductionButton.vue?vue&type=template&id=3a8c59fe&lang=pug"
import script from "./SetStatusInProductionButton.vue?vue&type=script&lang=js"
export * from "./SetStatusInProductionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports